module.exports = __webpack_public_path__ + "img/Logos.b07681f4.png";